<script>
  import {getContext} from 'svelte';
  import {envUtil} from '@/helper/env';
  import {genAppStoreUrl, genGooglePlayUrl} from '@/helper/download';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  $: downloadBtns = [
    {
      url: genAppStoreUrl(),
      label: LG(lang.AppStore),
      img: envUtil.isMobile ? IMAGES.H5_APPLE : IMAGES.APPLE,
    },
    {
      url: genGooglePlayUrl(),
      label: LG(lang.GooglePlay),
      img: envUtil.isMobile ? IMAGES.H5_GOOGLE_PLAY : IMAGES.GOOGLE_PLAY,
    },
  ];

  function bntClickHandler(url) {
    return function () {
      window.open(url, '_blank', 'noopener');
    };
  }
</script>

<style>
  .outer {
    background: #fff;
  }
  .wrap {
    margin: 0 auto;
    padding: 80px 0 120px;
    width: 1200px;
    background: #fff;
  }
  .caption {
    margin-top: 0;
    margin-bottom: 56px;
    font-size: 48px;
    font-family: gilroy-bold;
  }
  .desc {
    width: 500px;
  }
  .simulate {
    width: 510px;
    height: 310px;
  }
  .download-btn {
    border: 0;
    padding: 0;
    background: transparent;
  }
  .download-btn + :global(.download-btn) {
    margin-left: 12px;
  }
  .download-btn img {
    height: 50px;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      padding: 12px 16px 56px;
      width: auto;
    }
    .caption {
      margin-bottom: 16px;
      font-size: 18px;
    }
    .sub-title {
      margin-bottom: 24px;
    }
    .content {
      flex-direction: column-reverse;
      align-items: center;
    }
    .content .left {
      margin-top: 20px;
      width: 100%;
    }
    .simulate {
      width: 100%;
      height: auto;
    }
    .qrcode {
      margin-top: 20px;
      border-radius: 20px;
      padding: 16px 20px;
      background: #f9f9f9;
    }
    .download-wrap {
      display: flex;
      flex-direction: column-reverse;
    }
    .download-wrap button {
      display: block;
    }
    .download-wrap button img {
      width: 32px;
      height: 32px;
    }
    .btns-wrap {
      justify-content: space-around;
    }
  }
</style>

<section class="outer">
  <div class="wrap">
    <h2 class="caption">{LG(lang.TradeCrypto)}</h2>
    <div class="sub-title mb12 fw2">{LG(lang.TradeCryptocurrenciesWith)}</div>
    <div class="content df aife jcsb">
      <div class="left">
        <div class="desc mb24 T3 xs:dn">
          {LG(lang.PhemexProvidesBoth)}
        </div>
        <div class="download-wrap">
          <div class="qrcode df aife">
            <img width="116" height="116" src={IMAGES.DOWNLOAD_QRCODE} alt="QR code to download the app" />
            <div class="ml16 fw2">
              <div>Scan to Download</div>
              <div class="mt4">iOS & Android</div>
            </div>
          </div>
          <div class="btns-wrap df aic mt24">
            {#each downloadBtns as btn}
              <button class="download-btn" on:click={bntClickHandler(btn.url)}>
                <img class="br8 ovh" src={btn.img} alt="" />
                <div class="dn xs:db">{btn.label}</div>
              </button>
            {/each}
          </div>
        </div>
      </div>
      <img class="simulate" src={IMAGES.SIMULATE} alt="crypto trading platform" />
    </div>
  </div>
</section>
